import { useEffect, useState } from "react";
import { api, reloadConfig } from "../request/api";
import DataGrid, { Paging } from "devextreme-react/data-grid";
import { Column, SearchPanel } from "devextreme-react/data-grid";
import { EAgreementType } from "../Types/EAgreementType";

const EAgreements = () => {
  const [eAgreements, setEAgreements] = useState<EAgreementType[]>();
  const getData = async () => {
    reloadConfig();
    const { data } = await api.get<EAgreementType[]>("EAgreement/GetAgreements");
    setEAgreements(data);


  };
  useEffect(() => {


    getData();
  }, []);

  return (
    <>
      <div className="mainTitle">Moje umowy</div>
      <DataGrid
        id="gridContainer"
        dataSource={eAgreements}
        showBorders={true}
        selection={{ mode: "single" }}
        hoverStateEnabled={true}
      >
        <SearchPanel visible={true} width={240} placeholder="Wyszukaj..." />
        <Column dataField="id" dataType="string" caption="Id" />
        <Column dataField="agr_string_number" caption="Numer" />
        <Column
          dataField="agr_begin_date"
          dataType="date"
          caption="Data rozpoczęcia"
          format="dd.MM.yyyy"
        />
        <Column
          dataField="agr_end_date"
          dataType="date"
          caption="Data zakończenia"
          format="dd.MM.yyyy"
        />
        <Paging defaultPageSize={15} />
      </DataGrid>
    </>
  );
};

export { EAgreements };
